import React, { useEffect, useMemo } from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { SubscriptionInterface } from "src/store/callrecorder/subscriptionsSlice";
import { fetchSubscriptions } from "src/actions/callrecorder/subscriptionsActions";
import { formattedDate } from "src/helpers/DateHelpers";
import Pagination from "src/componets/Pagination";

import { Tag } from "antd";

interface ListTableInterface {
  filterParams: object;
  limit?: number;
}

const _ListTable = ({ filterParams, limit = 25 }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.callrecorder.subscriptions.ids);
  const entities = useAppSelector(state => state.callrecorder.subscriptions.entities);
  const count = useAppSelector(state => state.callrecorder.subscriptions.count);
  const data = ids ? ids.map(id => entities[id]) : [];

  const params = useMemo(() => ({
    limit,
    ...filterParams
  }), [limit, filterParams]);

  useEffect(() => {
    dispatch(fetchSubscriptions(params));
  }, [params, dispatch]);

  const columns: ColumnsType<SubscriptionInterface> = [
    {
      key: 'id',
      title: 'ID',
      render: (_, { id }) => <small>{`#${id}`}</small>,
      width: 60
    },

    {
      key: 'active',
      title: 'Active',
      render: (_, { active }) => active ? <Tag color="success">yes</Tag> : <Tag color="default">no</Tag>,
      width: 60
    },

    {
      key: 'productid',
      title: 'Product ID',
      render: (_, { productid }) => <small>{productid}</small>,
      width: 150
    },

    {
      key: 'expired_at',
      title: 'Expired',
      render: (_, { expired_at }) => <small>{formattedDate(expired_at).dateTime}</small>,
      width: 125
    },

    {
      key: 'created_at',
      title: 'Created',
      render: (_, { created_at }) => <small>{formattedDate(created_at).dateTime}</small>,
      width: 125
    },
  ];

  return (
    <div>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
